export default __webpack_public_path__ + "04ff9e7bf05adb2d095f8e273a534998.png";